import React, { useContext } from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import { Segment, Dropdown, Container } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { filterGraphicsOptions } from "../../../app/util/graphicsOptions";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";

let data = [{ name: "total", value: 0 }];
let total = 0;
const COLORS = ["#FF8042", "#00C49F", "#0088FE"];
const RADIAN = Math.PI / 180;
const renderLabel = function (entry) {
  const radius =
    entry.innerRadius + (entry.outerRadius - entry.innerRadius) * 0.5;
  const x = entry.cx + radius * Math.cos(-entry.midAngle * RADIAN);
  const y = entry.cy + radius * Math.sin(-entry.midAngle * RADIAN);
  return (
    <g>
      <text
        x={entry.cx}
        y={entry.cy}
        dy={8}
        textAnchor="middle"
        fill="ffff"
        fontSize={25}
      >
        {total}
      </text>
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > entry.cx ? "start" : "end"}
        dominantBaseline="central"
      >
         {entry.value !== 0 ? entry.value: ''}
      </text>
    </g>
  );
};

const FailedDian: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    countRejectDian,
    rejectDian,
    valueFilterReject,
    filterSwitch,
    loadRejectDian,
    detailReject,
  } = rootStore.dashboardStore;
  data = rejectDian;
  total = countRejectDian;
  return (
    <Segment clearing>
      <div>
        <div className="graphictitle">
          <p>Envíos fallidos a la Dian</p>
        </div>
        <div className="graphicfilter">
          <Dropdown
            className="floatright"
            selection
            options={filterGraphicsOptions}
            onChange={(e, data) => filterSwitch(data.value, false)}
            defaultValue={valueFilterReject}
          />
        </div>
      </div>

      {!loadRejectDian ? (
        <LoadingComponent content="Cargando" />
      ) : total === 0 ? (
        <div className="graphicontent">
          <Container textAlign="center">
            <p className="zerolabelstyle">Sin información disponible</p>
          </Container>
        </div>
      ) : (
        <div className="graphicontwithoutpadd">
          <ResponsiveContainer minHeight={250} minWidth={100}>
            <PieChart>
              <Tooltip cursor={false} />
              <Legend verticalAlign="bottom" />
              <Pie
                data={data}
                innerRadius={50}
                labelLine={false}
                label={renderLabel}
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <Link to="#" onClick={detailReject}>
            Detalle
          </Link>
        </div>
      )}
    </Segment>
  );
};
export default observer(FailedDian);
